import SourceCollapsibleHeader from "./SourceCollapsibleHeader";

export default SourceCollapsibleHeader;
export { SourceCollapsibleHeader };
